function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CustomLoader from "@common/components/CustomLoader";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { deleteAuthToken, getFullUserDetails, openModal, openPromotions, removeUserDetails } from "@common/actions";
import { ACCOUNT_LIST_ITEMS, ACCOUNT_LIST_TYPES, CONTEXT_ON_MATCH_ACTIONS } from "@common/constants";
import { calculateMenuWidth, deleteOrderObject, deleteSessionLockTime, deleteTokenObject } from "@common/services/helpers";
import { contextMatch } from "@common/utils/helpers";
import { ACCOUNT, ACCOUNT_MENU, ACCOUNT_MENU_NAME_HIDDEN, CHANGE_PASSWORD, KEY_ENTER, KEY_SPACE, MESSAGE_MODULE, PRIVACY_POLICY, PRIVACY_POLICY_URL, REDIRECT_DEFAULT_ROUTE, ROUTE_ORDER, SETTINGS, TERMS_AND_CONDITIONS, TERMS_AND_CONDITIONS_URL, TV_BOX_LINK } from "@config/constants";
import { castArray, isEmpty } from "lodash";
var AccountMenu = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(AccountMenu, Component);
    var _super = _create_super(AccountMenu);
    function AccountMenu(props) {
        _class_call_check(this, AccountMenu);
        var _this;
        _this = _super.call(this, props);
        var _this1 = _assert_this_initialized(_this);
        _define_property(_assert_this_initialized(_this), "openPromotions", function() {
            var _ref = _async_to_generator(function(plan) {
                return _ts_generator(this, function(_state) {
                    try {
                        plan && _this1.props.openPromotions(plan);
                    } catch (error) {
                        console.error(error);
                    }
                    return [
                        2
                    ];
                });
            });
            return function(plan) {
                return _ref.apply(this, arguments);
            };
        }());
        _this.state = {
            anchorEl: null,
            isVideoPlayerOpened: props.videoPlayer.isOpen,
            menuItemsPrototype: null
        };
        _this.handleClose = _this.handleClose.bind(_assert_this_initialized(_this));
        _this.handleClick = _this.handleClick.bind(_assert_this_initialized(_this));
        _this.openModal = _this.openModal.bind(_assert_this_initialized(_this));
        _this.handleClickOutside = _this.handleClickOutside.bind(_assert_this_initialized(_this));
        _this.redirectToSubscriptions = _this.redirectToSubscriptions.bind(_assert_this_initialized(_this));
        _this.logout = _this.logout.bind(_assert_this_initialized(_this));
        _this.toggleFromKeyboard = _this.toggleFromKeyboard.bind(_assert_this_initialized(_this));
        _this.handleCloseFromKeyboard = _this.handleCloseFromKeyboard.bind(_assert_this_initialized(_this));
        _this.logoutGoogle = _this.logoutGoogle.bind(_assert_this_initialized(_this));
        _this.getMenuItemsMap = _this.getMenuItemsMap.bind(_assert_this_initialized(_this));
        // this.getAuthInstance = this.getAuthInstance.bind(this);
        _this.accountMenuRef = null;
        return _this;
    }
    _create_class(AccountMenu, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_props, i18n, userDetails, prismic;
                    return _ts_generator(this, function(_state) {
                        // gapi.load('auth2', () => {
                        //     gapi.auth2.init();
                        // });
                        // TODO: This is fucking absurd ?
                        // The component handles this by default
                        // Rework whole component
                        document.addEventListener("click", _this.handleClickOutside);
                        document.addEventListener("touchend", _this.handleClickOutside);
                        // Adding to absurdity ...
                        document.addEventListener("wheel", _this.handleClose);
                        _this_props = _this.props, i18n = _this_props.i18n, userDetails = _this_props.userDetails, prismic = _this_props.prismic;
                        _this.setState({
                            menuItemsPrototype: _this.renderMenuItems(i18n, userDetails, prismic)
                        });
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                var _this_props = this.props, i18n = _this_props.i18n, userDetails = _this_props.userDetails, prismic = _this_props.prismic;
                if (prevProps.i18n !== i18n || prevProps.userDetails !== userDetails || prevProps.prismic !== prismic) {
                    this.setState({
                        menuItemsPrototype: this.renderMenuItems(i18n, userDetails, prismic)
                    });
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                document.removeEventListener("click", this.handleClickOutside);
                document.removeEventListener("touchend", this.handleClickOutside);
                document.removeEventListener("wheel", this.handleClose);
            }
        },
        {
            // here we are checking if the videoPlayer isOpen state is being toggled
            // and we are closing the account menu if true
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps(nextProps, nextState) {
                if (nextProps.videoPlayer.isOpen !== this.state.isVideoPlayerOpened) {
                    this.setState({
                        anchorEl: null,
                        isVideoPlayerOpened: nextProps.videoPlayer.isOpen
                    });
                }
                if (nextProps.modal.isModalOpened && !nextState.anchorEl && nextState.anchorEl !== this.state.anchorEl) {
                    document.activeElement.blur();
                }
            }
        },
        {
            /**
     *  Handles click outside of account menu and calls
     *  handleClose method if click is outside account menu
     *  @param {Object} event
     */ key: "handleClickOutside",
            value: function handleClickOutside(event) {
                if (this.accountMenuRef && !this.accountMenuRef.contains(event.target)) {
                    this.handleClose();
                }
            }
        },
        {
            /**
     *  Open account menu and close it on MenuItem click
     *  @param {Object} event
     */ key: "handleClick",
            value: function handleClick(event) {
                event.stopPropagation();
                if (!this.props.userDetails.email || !this.props.userDetails.billingAddress) {
                    this.props.getFullUserDetails();
                }
                var eventTarget = event.currentTarget;
                this.state.anchorEl ? this.handleClose() : this.setState({
                    anchorEl: eventTarget
                });
            }
        },
        {
            /**
     *  Opens the account menu on space/enter
     *  param event {Object}
     */ key: "toggleFromKeyboard",
            value: function toggleFromKeyboard(event) {
                var key = event.which;
                if (key === KEY_SPACE || key === KEY_ENTER) {
                    this.handleClick(event);
                }
            }
        },
        {
            /**
     *  Closes the account menu
     */ key: "handleClose",
            value: function handleClose() {
                if (!this.state.anchorEl) return;
                this.setState({
                    anchorEl: null
                });
            }
        },
        {
            /**
     *  Closes the account menu on space/enter on any of the menu items
     *  param event {Object}
     */ key: "handleCloseFromKeyboard",
            value: function handleCloseFromKeyboard(event) {
                var key = event.which;
                if (key === KEY_SPACE || key === KEY_ENTER) {
                    this.handleClose();
                }
            }
        },
        {
            /**
     *  Logouts from google sign in, deletes the token object and redirects to default route (login)
     */ key: "logoutGoogle",
            value: function logoutGoogle(auth2) {
                var _this = this;
                auth2.signOut().then(function() {
                    _this.logout();
                });
            }
        },
        {
            /**
     *  Deletes the token object and redirects  to default route (login)
     */ key: "logout",
            value: function logout() {
                var _this_props_userDetails;
                this.props.removeUserDetails();
                deleteTokenObject();
                deleteSessionLockTime();
                deleteOrderObject();
                this.props.deleteAuthToken();
                if (((_this_props_userDetails = this.props.userDetails) === null || _this_props_userDetails === void 0 ? void 0 : _this_props_userDetails.cf_terms) === false) {}
                location.href = "".concat(location.origin).concat(REDIRECT_DEFAULT_ROUTE);
            // location.reload();
            }
        },
        {
            // /**
            //  *  Checks for Google auth instance and logouts from google too if present
            //  */
            // getAuthInstance() {
            //     const auth2 = gapi.auth2.getAuthInstance().isSignedIn.get();
            //     auth2 ? this.logoutGoogle(gapi.auth2.getAuthInstance()) : this.logout();
            // }
            /**
     *  Opens the modal
     *  @param event {Object}
     *  @param modalName {String}
     *  @param modalProps {Object}
     */ key: "openModal",
            value: function openModal(event, modalName, modalProps) {
                event.stopPropagation();
                this.props.openModal(modalName, modalProps);
            }
        },
        {
            /**
     * Redirects to subscriptions
     * @param event
     */ key: "redirectToSubscriptions",
            value: function redirectToSubscriptions(event) {
                event.stopPropagation();
                deleteOrderObject();
                this.props.history.push(ROUTE_ORDER);
            }
        },
        {
            key: "getMenuItemsMap",
            value: function getMenuItemsMap(i18n, currentPlanPrismic) {
                var _this = this;
                var _obj;
                return _obj = {}, _define_property(_obj, ACCOUNT_LIST_ITEMS.CHANGE_PASSWORD, {
                    title: i18n.account.changePassword,
                    onClick: function(event) {
                        return _this.openModal(event, ACCOUNT, {
                            onlyChangePassword: true,
                            initialComponent: CHANGE_PASSWORD
                        });
                    }
                }), _define_property(_obj, ACCOUNT_LIST_ITEMS.ACCOUNT_MODAL, {
                    title: i18n.account.account,
                    onClick: function(event) {
                        return _this.openModal(event, ACCOUNT);
                    }
                }), _define_property(_obj, ACCOUNT_LIST_ITEMS.SUBSCRIPTIONS, {
                    title: i18n.account.subscriptions,
                    onClick: this.redirectToSubscriptions
                }), _define_property(_obj, ACCOUNT_LIST_ITEMS.PROMOTIONS, {
                    title: i18n.account.promotions,
                    onClick: function() {
                        return _this.openPromotions(currentPlanPrismic);
                    }
                }), _define_property(_obj, ACCOUNT_LIST_ITEMS.TV_BOX, {
                    title: i18n.account.tvBox,
                    onClick: function() {
                        return window.open(TV_BOX_LINK, "_blank");
                    }
                }), // [ACCOUNT_LIST_ITEMS.MESSAGE_MODULE]: {
                //     title: "Съобщения",
                //     onClick: (event) => this.openModal(event, MESSAGE_MODULE),
                // },
                _define_property(_obj, ACCOUNT_LIST_ITEMS.SETTINGS, {
                    title: i18n.settings.modalTitle,
                    onClick: function(event) {
                        return _this.openModal(event, SETTINGS);
                    }
                }), _define_property(_obj, ACCOUNT_LIST_ITEMS.TERMS_AND_CONDITIONS, {
                    title: i18n.account.terms,
                    onClick: function(event) {
                        return !isEmpty(TERMS_AND_CONDITIONS_URL) ? window.open(TERMS_AND_CONDITIONS_URL, "_blank") : _this.openModal(event, TERMS_AND_CONDITIONS, {
                            title: i18n.termsAndConditions.title,
                            text: i18n.termsAndConditions.text
                        });
                    }
                }), _define_property(_obj, ACCOUNT_LIST_ITEMS.PRIVACY_POLICY, {
                    title: i18n.privacyPolicy.title,
                    onClick: function(event) {
                        return !isEmpty(PRIVACY_POLICY_URL) ? window.open(PRIVACY_POLICY_URL, "_blank") : _this.openModal(event, PRIVACY_POLICY, {
                            title: i18n.privacyPolicy.title,
                            text: i18n.privacyPolicy.text
                        });
                    }
                }), _define_property(_obj, ACCOUNT_LIST_ITEMS.LOG_OUT, {
                    title: i18n.account.logout,
                    onClick: function() {
                        return _this.logout();
                    }
                }), _obj;
            }
        },
        {
            key: "renderMenuItems",
            value: function renderMenuItems(i18n, userDetails, prismic) {
                var _this = this;
                var _prismic_subscriptions;
                var prismicPlanItems = castArray((prismic === null || prismic === void 0 ? void 0 : (_prismic_subscriptions = prismic.subscriptions) === null || _prismic_subscriptions === void 0 ? void 0 : _prismic_subscriptions.plans_items) || []);
                var subscription = userDetails.subscription;
                var currentPlanPrismic = !isEmpty(subscription) && (prismicPlanItems === null || prismicPlanItems === void 0 ? void 0 : prismicPlanItems.find(function(plan) {
                    return plan.id === subscription[0].planId;
                }));
                var menuItemsMap = this.getMenuItemsMap(i18n, currentPlanPrismic);
                var context = {
                    currentPlanPrismic: currentPlanPrismic,
                    userDetails: userDetails
                };
                var filteredItems = ACCOUNT_MENU.filter(function(item) {
                    var _item_hidden;
                    var hidden = (_item_hidden = item.hidden) !== null && _item_hidden !== void 0 ? _item_hidden : false;
                    if (item.matchContext) {
                        var action = contextMatch(context, item.matchContext);
                        if (action === null) return !hidden;
                        hidden = action === CONTEXT_ON_MATCH_ACTIONS.HIDE;
                    }
                    return !hidden;
                });
                return filteredItems.map(function(param, index) {
                    var type = param.type, item = param.item;
                    if (type === ACCOUNT_LIST_TYPES.ITEM) {
                        var content = menuItemsMap[item];
                        return /*#__PURE__*/ _jsx(MenuItem, {
                            className: "menu-item",
                            onKeyDown: _this.handleCloseFromKeyboard,
                            onClick: content.onClick,
                            children: content.title
                        }, item);
                    }
                    if (type === ACCOUNT_LIST_TYPES.DIVIDER) {
                        // using index here should be fine
                        return /*#__PURE__*/ _jsx("hr", {
                            tabIndex: "-1"
                        }, "".concat(type, "_").concat(index));
                    }
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _userDetails_planDetails;
                var anchorEl = this.state.anchorEl;
                var _this_props = this.props, i18n = _this_props.i18n, videoPlayer = _this_props.videoPlayer, userDetails = _this_props.userDetails, screenType = _this_props.screenType;
                var menuAdditionalClass = videoPlayer.isOpen && !screenType.mobile ? " open-up" : "";
                var billingAddress = (userDetails === null || userDetails === void 0 ? void 0 : userDetails.billingAddress) || null;
                var menuWidth = calculateMenuWidth();
                anchorEl ? this.props.setMenuFlag(true) : this.props.setMenuFlag(false);
                // TODO: Add dynamic config if more conditions are needed
                var isNameHidden = ACCOUNT_MENU_NAME_HIDDEN || (userDetails === null || userDetails === void 0 ? void 0 : (_userDetails_planDetails = userDetails.planDetails) === null || _userDetails_planDetails === void 0 ? void 0 : _userDetails_planDetails.oldClient);
                return /*#__PURE__*/ _jsxs("div", {
                    ref: function(node) {
                        return _this.accountMenuRef = node;
                    },
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            className: "icon icon-account-circle pointer",
                            "aria-owns": anchorEl ? "account-menu" : null,
                            "aria-haspopup": "true",
                            tabIndex: "0",
                            "data-for": "header-tooltip",
                            "data-tip": i18n.account.account,
                            onKeyDown: this.toggleFromKeyboard,
                            onClick: this.handleClick
                        }),
                        /*#__PURE__*/ _jsxs(Menu, {
                            className: "menu".concat(menuAdditionalClass),
                            id: "account-menu",
                            anchorEl: anchorEl,
                            open: Boolean(anchorEl),
                            onClose: this.handleClose,
                            PaperProps: {
                                style: {
                                    minWidth: menuWidth
                                }
                            },
                            children: [
                                /*#__PURE__*/ _jsx("br", {}),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "menu-item name-email",
                                    tabIndex: "-1",
                                    children: [
                                        isNameHidden ? i18n.authentication.email : !billingAddress ? /*#__PURE__*/ _jsx(CustomLoader, {
                                            i18n: i18n,
                                            numberOfLines: 2
                                        }) : /*#__PURE__*/ _jsxs("p", {
                                            className: "name",
                                            children: [
                                                billingAddress.firstName,
                                                " ",
                                                billingAddress.lastName
                                            ]
                                        }),
                                        userDetails && /*#__PURE__*/ _jsx("p", {
                                            className: "email",
                                            children: userDetails.email
                                        })
                                    ]
                                }),
                                this.state.menuItemsPrototype
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return AccountMenu;
}(Component);
var mapStateToProps = function(param) {
    var i18n = param.i18n, videoPlayer = param.videoPlayer, userDetails = param.userDetails, screenType = param.screenType, modal = param.modal, prismic = param.prismic;
    return {
        i18n: i18n,
        videoPlayer: videoPlayer,
        userDetails: userDetails,
        screenType: screenType,
        modal: modal,
        prismic: prismic
    };
};
export default withRouter(connect(mapStateToProps, {
    openModal: openModal,
    removeUserDetails: removeUserDetails,
    deleteAuthToken: deleteAuthToken,
    openPromotions: openPromotions,
    getFullUserDetails: getFullUserDetails
})(AccountMenu));
